/* eslint-disable */
import React, { Component } from 'react'; 
import HTMLText from '../UiComponent/HTMLText';
import InputField from '../UiComponent/InputField'
import  './FormPage.scss'
import * as api from '../js/api.js';

class RaceInfoTable extends Component {
	constructor(props) {
		super(props);	
		this.state = {
			fMsg:this.props.labelText,
			info:this.props.raceInfo == null ? {} :this.props.raceInfo
		};	
	}
    
	//fee
	//max race

    componentWillReceiveProps(nextProps) {
		this.setState({fMsg:nextProps.labelText,info:nextProps.raceInfo});
	} 
	
	componentDidMount() {    
	
	}

	componentWillUnmount() {
	}
    
  

	render() {	
		return (
            <React.Fragment>
				<table className='info-table'>
					<tbody>
						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.raceTitleZh+":<br/>" + this.state.fMsg.raceTitleEn +":"}/>
							</td>
							<td>
								<HTMLText text={this.state.info.raceTitleZh +"<br/>" + this.state.info.raceTitleEn}/>
							</td>
						</tr>
					
            <tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.mainOrganizerZh +":<br/>" + this.state.fMsg.mainOrganizerEn +":"}/>
							</td>
							<td>
								<HTMLText text={this.state.info.mainOrganizerZh +"<br/>" + this.state.info.mainOrganizerEn}/>
							</td>
						</tr>
					{this.state.info.coOrganizerZh && (	<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.coOrganizerZh +":<br/>" + this.state.fMsg.coOrganizerEn +":"}/>
							</td>
							<td>
								<HTMLText text={this.state.info.coOrganizerZh +"<br/>" + this.state.info.coOrganizerEn}/>
							</td>
						</tr>)}
					
					

						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.raceDateZh +":<br/>" + this.state.fMsg.raceDateEn +":"}/>
							</td>
							<td>
								<HTMLText text={this.state.info.raceDateZh +"<br/>" + this.state.info.raceDateEn}/>
							</td>
						</tr>
					

						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.raceTimeZh +":<br/>" + this.state.fMsg.raceTimeEn +":"}/>
							</td>
							<td>
								<HTMLText text={this.state.info.raceTimeZh +"<br/>" + this.state.info.raceTimeEn}/>
							</td>
						</tr>
					
						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.locationZh +":<br/>" + this.state.fMsg.locationEn +":"}/>
							</td>
							<td>
								<HTMLText text={this.state.info.locationZh +"<br/>" + this.state.info.locationEn}/>
							</td>
						</tr>

						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.regPeriodZh +":<br/>" + this.state.fMsg.regPeriodEn +":"}/>
							</td>
							<td>
								<HTMLText text={this.state.info.regPeriodZh +"<br/>" + this.state.info.regPeriodEn}/>
							</td>
						</tr>					

						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.maxRaceZh +":<br/>" + this.state.fMsg.maxRaceEn +":"}/>
							</td>
							<td>

								{this.state.info.maxRaceDescEn !== null && this.state.info.maxRaceDescEn !== undefined && this.state.info.maxRaceDescEn !== "" &&
								(
									<HTMLText text={this.state.info.maxRaceDescZh +
								"<br/>" + this.state.info.maxRaceDescEn}/>
								) }

								{(this.state.info.maxRaceDescEn === null || this.state.info.maxRaceDescEn === undefined || this.state.info.maxRaceDescEn === "" )&&
								(
									<HTMLText text={this.state.fMsg ? (this.state.fMsg.maxRaceDescZh.replace('##1', this.state.info.maxRace) +
								"<br/>" + this.state.fMsg.maxRaceDescEn.replace('##1', this.state.info.maxRace)):''}/>
								) }
								
							</td>
						</tr>					

						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.feePerRaceZh +":<br/>" + this.state.fMsg.feePerRaceEn +":"}/>
							</td>
									<td>
										<HTMLText text={this.state.info.feePerRaceDescZh +
										"<br/>" + this.state.info.feePerRaceDescEn}/>		
									</td>
						</tr>				


					</tbody>
				</table>
            						 
            </React.Fragment>
		);
	}
}

export default RaceInfoTable;